"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomTableCell = exports.TableBody = exports.TableHead = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var Table = _interopRequireWildcard(require("reactabular-table"));

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// eslint-disable-next-line prefer-arrow-callback
var TableHead = _react.default.forwardRef(function TableHead(props, ref) {
  return _react.default.createElement(Table.Header, _extends({
    ref: ref
  }, props));
}); // eslint-disable-next-line prefer-arrow-callback


exports.TableHead = TableHead;

var TableBody = _react.default.forwardRef(function TableBody(props, ref) {
  return _react.default.createElement(Table.Body, _extends({
    ref: ref
  }, props));
}); // eslint-disable-next-line prefer-arrow-callback


exports.TableBody = TableBody;

var CustomTableCell = _react.default.forwardRef(function CustomTableCell(props, ref) {
  var render = props.render,
      rest = _objectWithoutProperties(props, ["render"]);

  if (render) {
    return _react.default.createElement(_TableCell.default, _extends({
      ref: ref
    }, rest));
  }

  return null;
});

exports.CustomTableCell = CustomTableCell;
process.env.NODE_ENV !== "production" ? CustomTableCell.propTypes = {
  render: _propTypes.bool
} : void 0;
CustomTableCell.defaultProps = {
  render: true
};

var CustomTable = function CustomTable(props) {
  return _react.default.createElement(Table.Provider, _extends({}, props, {
    renderers: {
      table: _Table.default,
      header: {
        wrapper: _TableHead.default,
        row: _TableRow.default,
        cell: CustomTableCell
      },
      body: {
        wrapper: _TableBody.default,
        row: _TableRow.default,
        cell: CustomTableCell
      }
    }
  }));
};

process.env.NODE_ENV !== "production" ? CustomTable.propTypes = {
  children: _propTypes.node.isRequired,
  columns: (0, _propTypes.arrayOf)(_propTypes.object).isRequired
} : void 0;
var _default = CustomTable;
exports.default = _default;